export async function uploadToCloudinary(file: File): Promise<string> {
  const sigRes = await fetch("/api/upload-signature");
  if (!sigRes.ok) throw new Error("Failed to get upload signature");

  const { signature, timestamp, folder, cloud_name, api_key } = await sigRes.json();

  const formData = new FormData();
  formData.append("file", file);
  formData.append("signature", signature);
  formData.append("timestamp", String(timestamp));
  formData.append("folder", folder);
  formData.append("api_key", api_key);

  const uploadRes = await fetch(
    `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
    { method: "POST", body: formData }
  );

  if (!uploadRes.ok) {
    const err = await uploadRes.json();
    throw new Error(err.error?.message || "Cloudinary upload failed");
  }

  const data = await uploadRes.json();
  return data.secure_url as string;
}
